import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-security-information',
    templateUrl: './security-information.component.html',
    styleUrls: ['./security-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecurityInformationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
